import React, { useState } from 'react'
import Stack from '@mui/material/Stack'
import TextField from '@mui/material/TextField'
import InputAdornment from '@mui/material/InputAdornment'
import IconButton from '@mui/material/IconButton'
import Visibility from '@mui/icons-material/Visibility'
import VisibilityOff from '@mui/icons-material/VisibilityOff'

function FormMailUp({ handleChange, values, errors, touched }) {
  const [showPassword, setShowPassword] = useState(false)

  return (
    <Stack direction="column" spacing={2} paddingTop={3} sx={{ width: '60%' }}>
      <TextField
        label="Username"
        variant="outlined"
        name="username"
        onChange={handleChange}
        value={values.username}
        error={touched.username && Boolean(errors.username)}
        helperText={touched.username && errors.username}
        size={'small'}
        fullWidth
        autoComplete="off"
      />
      <TextField
        label="Password"
        variant="outlined"
        name="pwd"
        onChange={handleChange}
        value={values.pwd}
        error={touched.pwd && Boolean(errors.pwd)}
        helperText={touched.pwd && errors.pwd}
        size={'small'}
        fullWidth
        autoComplete="off"
        type={showPassword ? 'text' : 'password'}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                aria-label="mostra o nascondi la password"
                onClick={() => setShowPassword((prev) => !prev)}
                edge="end"
                size="small"
              >
                {showPassword ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            </InputAdornment>
          ),
        }}
      />
    </Stack>
  )
}

export default FormMailUp
